import { Polyline } from 'react-leaflet';
import { ICoordinate } from '../../../../../../../../../models/coordinate.model';
import Colors from '../../../../../../../../../helpers/colors.helper';

function MicromobilityPolyline({ coordinates, disabled }: { coordinates: ICoordinate[]; disabled: boolean }) {
  const opacity = disabled ? 0.35 : 1;
  const onTripLegPathOptions1 = { weight: 16, color: Colors.vtdBlue1000, opacity: opacity };
  const onTripLegPathOptions2 = { weight: 10, color: Colors.vtdWhite, opacity: opacity };

  return (
    <>
      <Polyline positions={coordinates.map((c) => [c.latitude, c.longitude])} pathOptions={onTripLegPathOptions1} />
      <Polyline positions={coordinates.map((c) => [c.latitude, c.longitude])} pathOptions={onTripLegPathOptions2} />
    </>
  );
}

export default MicromobilityPolyline;
